import { useLocalStorageState, useRequest } from 'ahooks';
import { get } from 'lodash';
import React from 'react';
import { portalLogin, loginDomain } from 'src/request/common';
import {
  ACCOUNT_INFO as _ACCOUNT_INFO,
  SEVER_URL as _SEVER_URL,
} from 'src/tools/constant';
import {
  //checkIsLoginExpire,
  generateKey,
  generateSalesChannelResources,
  generateStoreResources,
  //getLoginDomain,
  updateTimeStamp,
  userLogout,
} from 'src/tools/getUserInfo';
import { EResourcesAdmin } from 'src/types/common/resources';
import { modal } from 'src/utils/Modal';

const useLogin = () => {
  const { run: jumpToLogin } = useRequest(() => loginDomain(), {
    manual: true,
    onSuccess: (res) => {
      window?.location.replace(`${res}/login`);
    },
  });

  const url = new URL(window.location.href);
  const search = get(url, 'search');
  const params = new URLSearchParams(search);

  const [loading, setLoading] = React.useState(true);

  const k = generateKey(_ACCOUNT_INFO);
  const serverUrlK = generateKey(_SEVER_URL);

  const [info, setInfo] = useLocalStorageState<any>(k);
  const [serverUrl, setServerUrl] = useLocalStorageState<any>(serverUrlK);

  const storeUuid = params.get('storeUuid'); //getParameter('storeUuid');

  const token = params.get('token'); //getParameter('token');

  const configToken = params.get('configToken');

  const shouldUpdateUser = !!storeUuid && !!token;

  const handleOnStoreChange = (e) => {
    const key = get(e, 'key');
    const isPermissionChange = key === k;
    if (isPermissionChange) {
      try {
        const oldValueInString = get(e, 'oldValue');
        const newValueInString = get(e, 'newValue');
        if (!oldValueInString) {
          return;
        } else {
          const oldValue = JSON.parse(oldValueInString);
          const newValue = JSON.parse(newValueInString);
          const oStoreUuid = get(oldValue, 'storeUuid');
          const nStoreUuid = get(newValue, 'storeUuid');
          if (!oStoreUuid) {
            return;
          }
          if (oStoreUuid !== nStoreUuid) {
            alert('Store is switched!');
            modal.error({
              title: 'Current store is switched',
              content:
                'Store on this tab is switched, Please reload page or re-login',
              onOkText: 'Reload',
              onOk: () => {
                location.reload();
              },
              onCancelText: 'Login',
              onCancel: jumpToLogin,
            });
          } else {
            return;
          }
        }
        // console.log('oldValue', oldValue, 'newValue', newValue);
      } catch (e) {
        console.error(e);
      }
    }
  };

  React.useEffect(() => {
    window.addEventListener('storage', handleOnStoreChange);
    return () => {
      window.removeEventListener('storage', handleOnStoreChange);
    };
  }, []);

  const gotoLoginPage = () => {
    //const domain = getLoginDomain();
    modal.error({
      title: 'Login Error',
      content: 'Please Login in your account First',
      onOkText: 'Go to Login Page',
      //  onCancel: () => {
      //    return;
      //  },
      // onCancelText: 'Cancel',
      onOk: () => {
        jumpToLogin();
      },
    });
  };

  const handleOnShouldUpdate = () => {
    userLogout(); //请求token
    setInfo('');
    run();
  };
  React.useEffect(() => {
    if (!get(info, 'token') || !serverUrl) {
      // const isExpire = checkIsLoginExpire();
      if (shouldUpdateUser) {
        // console.log(1);

        handleOnShouldUpdate();
      } else {
        //console.log(1.1);
        gotoLoginPage(); //跳转
      }
    } else {
      if (shouldUpdateUser) {
        // console.log(2);
        handleOnShouldUpdate();
      } else {
        // console.log(3);
        setLoading(false); //正常登入
      }
    }
  }, []);

  const { run } = useRequest(() => portalLogin({ storeUuid, token }), {
    ready: shouldUpdateUser,

    manual: true,
    onSuccess: (res: any, params) => {
      const serverUrl = get(res, 'regionSetting.portalServer');
      setServerUrl(serverUrl);

      const {
        storeUuid,
        storeName,
        userUuid,
        userName,
        token: portalToken,
        storeOwner,
        configDomain,
        loginName,
      } = res;

      const { salesChannelPrivileges, storePrivileges } = res;
      const sar = generateSalesChannelResources({
        resources: salesChannelPrivileges || [],
      });
      const str = generateStoreResources({
        resources: storePrivileges || [],
      });

      setTimeout(() => {
        setLoading(false);
      }, 200);
      updateTimeStamp();
      setInfo({
        domain: configDomain,
        storeUuid,
        storeName,
        userUuid,
        userName,
        token: portalToken,
        configToken,
        storeResources: str,
        salesChannelResources: sar,
        storeOwner,
        [EResourcesAdmin.superAdmin]: storeOwner, //storeOwner,、
        loginName,
      });
      try {
        window.history.pushState({}, document.title, window.location.pathname);
      } catch (e) {
        console.error(e);
      }
    },
  });

  return {
    display: !loading,
  };
};
export default useLogin;
